import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class BOMServices {

  createBOM = async (payload) => {
    const bom = await Helpers.post({
      url: Constants.BOM,
      data: payload,
    });
    return bom;
  };

  createBOMv2 = async (payload) => {
    const bom = await Helpers.post({
      url: Constants.BOM_V2,
      data: payload,
    });
    return bom;
  };

  getBomJobworks = async (payload) => {
    let url = Constants.BOM_V2_JW;
    if (payload?.bomId) url += `?bom_id=${payload?.bomId}`;
    const bomJobworks = await Helpers.get({
      url,
    });
    return bomJobworks;
  };

  updateBomJobwork = async (payload) => {
    let url = `${Constants.BOM_V2}/br_line`;
    const updatedJobworks = await Helpers.put({
      url,
      data: payload,
    });
    return updatedJobworks;
  };

  updateBOM = async (payload) => {
    const bom = await Helpers.put({
      url: Constants.BOM,
      data: payload,
    });
    return bom;
  };

  updateBOMv2 = async (payload) => {
    const bom = await Helpers.put({
      url: Constants.BOM_V2,
      data: payload,
    });
    return bom;
  };

  updateBOMStatus = async (payload) => {
    const po = await Helpers.put({
      url: Constants.BOM_STATUS,
      data: payload,
    });
    return po;
  };

  updateBOMWorkflowStep = async (payload) => {
    const po = await Helpers.post({
      url: Constants.BOM_WORKFLOW,
      data: payload,
    });
    return po;
  };

  deleteBOM = async (payload) => {
    const po = await Helpers.delete({
      url: Constants.BOM,
      data: payload,
    });
    return po;
  };

  getBOM = async (orgId, tenantId, bomId, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, viewType, bomLinesViewType, searchBomByRm, approvalStatus, isMasterBom) => {
    let url = `${Constants.BOM}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (productSkuId) url += `product_sku_id=${productSkuId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (bomId) url += `bom_id=${bomId}&`;
    if (status) url += `is_active=${status}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (viewType) url += `view_type=${viewType}&`;
    if (bomLinesViewType) url += `bom_lines_view_type=${bomLinesViewType}&`;
    if (searchBomByRm) url += `rm_product_sku_ids=${searchBomByRm}&`;
    if (approvalStatus) url += `status=${approvalStatus}&`;
    if (isMasterBom) url += `is_master_bom=${isMasterBom}&`;
    const bom = await Helpers.get({ url });
    return bom;
  };

  activateBOM = async (payload) => {
    const bom = await Helpers.post({
      url: Constants.BOM_ACTIVATE,
      data: payload,
    });
    return bom;
  };
  // bulk upload bom

  bulkUploadBOM = async (payload) => {
    const url = `${Constants.BOM_V2}/bulk-upload/v2`;
    const data = new FormData();
    data.append('file', payload?.file || null);
    data.append('uom_mapping', JSON.stringify(payload?.uomMapping) || null);
    data.append('type', payload?.type || null);
    data.append('product_mapping', JSON.stringify(payload?.productNameMapping) || null);
    data.append('tenant_id', JSON.stringify(payload?.tenant_id) || null);
    data.append('tenant_ids_to_be_enabled', JSON.stringify(payload?.tenant_ids_to_be_enabled) || []);
    const bulkUpload = await Helpers.filePost({
      url,
      file: data,
    });
    return bulkUpload;
  };

  shareBOM = async (payload) => {
    const url = `${Constants.BOM_V2}/replicate`;
    const sharedBOM = await Helpers.put({
      url,
      data: payload,
    });
    return sharedBOM;
  };
}
export default new BOMServices();
